// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@werner/Overrides/Widgets/MyLists/MyListsHeader";
import { xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

headerStyles.container = {
    ...headerStyles.container,
    css: css`
        margin-bottom: 45px;
    `,
};
headerStyles.leftTopGridItem = {
    width: 12,
};

headerStyles.leftBottomGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        ${xScreen("lte", "sm")} {
            order: 1;
        }
    `,
};
headerStyles.rightTopGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        ${xScreen("lte", "sm")} {
            order: 2;
        }
    `,
};
headerStyles.rightBottomGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        align-items: flex-end;
        ${xScreen("lte", "md")} {
            order: 4;
        }
    `,
};
headerStyles.extendedGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        ${xScreen("lte", "md")} {
            order: 3;
        }
    `,
};
